import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth()

  if (loading) {
    return <div className="p-8 text-center">Loading…</div>
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return children
}

export default AdminRoute
